import { LocationType } from '@chilipiper/api-type-def'
import { ThirdPartiesType } from '@chilipiper/design-system'

interface LabelMapper {
  description?: string
  icon: ThirdPartiesType
  input?: {
    label: string
    placeholder: string
    type: 'text' | 'textarea'
  }
  name: string
}

const zoom: LabelMapper = {
  name: 'Zoom',
  icon: 'Zoom',
}

const webex: LabelMapper = { name: 'Webex', icon: 'Webex' }
const ringCentral: LabelMapper = {
  name: 'RingCentral Video',
  icon: 'RingCentral',
}

const goToMeeting: LabelMapper = {
  name: 'GoToMeeting',
  icon: 'GoToMeeting',
}

const hopin: LabelMapper = {
  name: 'Hopin Session',
  icon: 'Hopin',
}

const gong: LabelMapper = {
  name: 'Gong',
  icon: 'Gong',
}

const labelMap = new Map<string, LabelMapper>([
  ['Zoom', zoom],
  ['Zoom.USdetails', zoom],
  ['CustomTextField.Zoom', zoom],

  ['Webex', webex],
  ['Webex.Details', webex],
  ['CustomTextField.Webex', webex],

  ['GoToMeeting', goToMeeting],
  ['CustomTextField.GoToMeeting', goToMeeting],

  ['RingCentralVideo', ringCentral],
  ['RingCentralVideo.Details', ringCentral],
  ['CustomTextField.RingCentralVideo', ringCentral],

  ['Phone', { name: 'phone', icon: 'Phone', description: 'callTheHost' }],
  ['Guest.Phone', { name: 'myPhone', icon: 'Phone' }],

  ['Location', { name: 'hostsLocation', icon: 'Location' }],
  ['Guest.Location', { name: 'myLocation', icon: 'Location' }],

  ['CustomTextField.Custom', { name: 'useHostsSettings', icon: 'ConferenceDetails' }],
  ['Conference.Details', { name: 'useHostsConferenceDetails', icon: 'ConferenceDetails' }],

  ['GoogleMeet', { name: 'Google Meet', icon: 'GoogleMeet' }],
  ['MicrosoftTeams', { name: 'Microsoft Teams', icon: 'MicrosoftTeams' }],

  [
    'AskTheGuest',
    {
      name: 'provideMyOwn',
      icon: 'ConferenceDetails',
      description: 'provideYourOwnMeetingLink',
      input: {
        label: 'meetingLocation',
        placeholder: 'enter',
        type: 'textarea',
      },
    },
  ],

  [
    'CallTheGuest',
    {
      name: 'phone',
      icon: 'Phone',
      description: 'callTheGuest',
      input: {
        label: 'phone',
        placeholder: 'enter',
        type: 'text',
      },
    },
  ],

  ['Hopin', hopin],

  ['Gong', gong],
])

const buildCompositeKey = (location: LocationType) => {
  if (location.type === 'RawDynamicTag') {
    return `${location.objectType === 'Guest' ? 'Guest.' : ''}${location.name}`
  }

  if (location.type === 'CustomTextField') {
    return `${location.type}.${location.fieldType}`
  }

  if (location.type === 'CallTheGuest') {
    return location.type
  }

  return location.type as string
}

export const getLocationsLabels = (locations: LocationType[]) => {
  return locations.map(location => {
    const key = buildCompositeKey(location)

    const label = labelMap.get(key)

    if (!label) {
      throw new Error(`missing label for ${key}`)
    }

    return { label, location }
  })
}
